// @core/api/endpoints/bootstrap/get_wizard_steps.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetWizardStepsResponse,
} from '../../../types/bootstrap';

const BASE_PATH = '/bootstrap';

/**
 * Get wizard steps
 * Returns all wizard steps with their status, validation state, and previously saved data. Sensitive fields (passwords, secrets) are masked.
 * @public This endpoint does not require authentication
 */
export async function GetWizardSteps(
  params?: {
  },
  options?: RequestOptions
): Promise<GetWizardStepsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/setup/steps`;
  const requestOptions = { ...options, skipAuth: true };
  return client.get<GetWizardStepsResponse>(requestPath, { ...requestOptions, params });
}
